import axios from "axios";
import api from "../api";
import store from "@/store";
import filter_service from "./filter-service";

function create(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(api.register_customer, params)
      .then(async (response) => {
        store.dispatch(
          "alerts/success",
          "Registrado! Um administrador irá aprovar seu cadastro em breve."
        );
        resolve({
          customer: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function read(params = {}) {
  let paginate = params.with_pagination ? { paginate: true } : {};
  let filter_params = filter_service.filter_params(params);
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.customers}${filter_params}`, params)
      .then((response) => {
        if (params.with_pagination) {
          resolve({
            customers: { ...paginate, ...response.data },
          });
        } else {
          resolve({
            customers: response.data,
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function update(body = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.customers}/${body.id}`, body.params)
      .then(async (response) => {
        store.dispatch("alerts/success", "Cliente atualizado com sucesso");
        resolve({
          customer: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(`${api.customers}/${id}`)
      .then((response) => {
        resolve({
          customer: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function get(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .get(`${api.customers}/${id}`)
      .then((response) => {
        resolve({
          customer: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function createEndUser(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(api.end_user, params)
      .then(async (response) => {
        store.dispatch("alerts/success", "Cliente final criado com sucesso");
        resolve({
          end_user: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateEndUser(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.end_user}/${params.id}`, params.params)
      .then(async (response) => {
        store.dispatch(
          "alerts/success",
          "Cliente final atualizado com sucesso"
        );
        resolve({
          end_user: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function exportCsv(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.customers}/export/csv`, params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function exportMetricsCsv(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.customers}/export/metricsCsv`, params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function importCsv(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.customers}/import/csv`, params, {
        transformRequest: (data, headers) => {
          delete headers.common["Content-type"];
          return data;
        },
      })
      .then((response) => {
        store.dispatch("alerts/success", "Dados importados com sucesso!");
        resolve(response);
      })
      .catch((error) => {
        store.dispatch("alerts/error", "Erro ao importar dados");
        reject(error);
      });
  });
}

function register(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(api.register_customer_with_log, params)
      .then(async (response) => {
        store.dispatch(
          "alerts/success",
          "Registrado com sucesso!"
        );
        resolve({
          customer: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  destroy,
  get,
  createEndUser,
  updateEndUser,
  exportCsv,
  exportMetricsCsv,
  importCsv,
  register
};
